import React from 'react';
import PropTypes from 'prop-types';

import Header from 'components/header';
import { usePublishStatus } from 'hooks/ApiStatus';
import ToastApi from 'services/toast';
import { useTranslation } from 'react-i18next';
import SideMenu from './sideMenu';

import {
  PageWrapper, ContentHeaderWrapper, ContentWrapper,
} from './styles';

const MainLayout = ({ children, routes }) => {
  const { t } = useTranslation();

  usePublishStatus((content) => {
    if (content.success) {
      ToastApi.success(t('pages.publicationPage.successPublishMessage'));
    } else {
      ToastApi.error(t('pages.publicationPage.errorPublishMessage'));
    }
  });

  return (
    <PageWrapper>
      <SideMenu routes={routes} />
      <ContentHeaderWrapper>
        <Header />
        <ContentWrapper>
          {children}
        </ContentWrapper>
      </ContentHeaderWrapper>
    </PageWrapper>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node,
  routes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
};

MainLayout.defaultProps = {
  children: null,
};

export default MainLayout;
